import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LanguageProvider } from './i18n/LanguageContext';
import { SettingsProvider } from './contexts/SettingsContext';
import { Toaster } from './components/ui/sonner';

// Pages
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';
import LandingPage from './pages/LandingPage';
import LeadDetail from './pages/LeadDetail';
import ClientsDashboard from './pages/ClientsDashboard';
import ClientDetail from './pages/ClientDetail';
import Settings from './pages/Settings';
import HomeownerLogin from './pages/HomeownerLogin';
import HomeownerRegister from './pages/HomeownerRegister';
import HomeownerDashboard from './pages/HomeownerDashboard';
import Calendar from './pages/Calendar';
import Contacts from './pages/Contacts';
import DataViewer from './pages/DataViewer';
import PricingManager from './pages/PricingManager';
import Resources from './pages/Resources';
import AITraining from './pages/AITraining';

import './App.css';

function App() {
  return (
    <LanguageProvider>
      <SettingsProvider>
        <div className="App">
          <Toaster position="top-center" richColors />
          <BrowserRouter>
            <Routes>
              {/* Public */}
              <Route path="/" element={<LandingPage />} />
              <Route path="/login" element={<Login />} />
              
              {/* Homeowner Portal */}
              <Route path="/homeowner/login" element={<HomeownerLogin />} />
              <Route path="/homeowner/register" element={<HomeownerRegister />} />
              <Route path="/homeowner" element={<HomeownerDashboard />} />
              
              {/* Admin Dashboard with tabs */}
              <Route path="/admin" element={<AdminDashboard />} />
              
              {/* Hidden CRM Access Route */}
              <Route path="/app.crm" element={<AdminDashboard />} />
              <Route path="/pipeline" element={<AdminDashboard />} />
              
              {/* Calendar */}
              <Route path="/calendar" element={<Calendar />} />
              
              {/* Contacts */}
              <Route path="/contacts" element={<Contacts />} />
              
              {/* Lead Detail (accessed from admin) */}
              <Route path="/leads/:leadId" element={<LeadDetail />} />
              
              {/* Client Detail */}
              <Route path="/clients/:clientId" element={<ClientDetail />} />
              
              {/* Settings */}
              <Route path="/settings" element={<Settings />} />
              
              {/* Data Viewer */}
              <Route path="/data" element={<DataViewer />} />
              
              {/* Pricing Manager */}
              <Route path="/pricing" element={<PricingManager />} />
              
              {/* Resources */}
              <Route path="/resources/:section" element={<Resources />} />
              <Route path="/resources" element={<Resources />} />
              
              {/* AI Training */}
              <Route path="/ai-training" element={<AITraining />} />
              
              {/* Legacy redirects */}
              <Route path="/leads" element={<Navigate to="/admin?tab=leads" replace />} />
              <Route path="/clients" element={<Navigate to="/admin?tab=clients" replace />} />
              <Route path="/estimates" element={<Navigate to="/admin?tab=leads" replace />} />
              
              {/* Fallback */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </div>
      </SettingsProvider>
    </LanguageProvider>
  );
}

export default App;
